import { ExtractedItemAnswer } from "@zitelab/ionic-fhir-questionnaires";

export const calculateMdi2 = (answers: {
  [key: string]: ExtractedItemAnswer;
}): { score: number; color: string } => {
  const relevantLinkIds = ["feltSad", "lackedMotivation"];
  let maxScore: number = 0;
  const overallScore = Object.values(answers)
    .filter(answer => relevantLinkIds.includes(answer.linkId))
    .reduce((acc, answer) => {
      const scoreDict = {
        ALWAYS: 5,
        MOST_OF_THE_TIME: 4,
        MORE_THAN_HALF_THE_TIME: 3,
        LESS_THAN_HALF_THE_TIME: 2,
        SOMETIMES: 1,
        NEVER: 0
      };
      const itemScore = scoreDict[answer.answer.code] || 0;
      maxScore = itemScore > maxScore ? itemScore : maxScore;
      return acc + itemScore;
    }, 0);
  return {
    score: overallScore,
    color: maxScore >= 3 ? "dashboard-item-red" : "dashboard-item-green"
  };
};



// WEBPACK FOOTER //
// ./src/app/utils/calculate-mdi2.ts